<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card>
      <v-alert v-model="alertFlg" type="error" density="compact" :title=errorMsg closable class="ma-2" />

      <v-card-text class="pa-4 pre-line grey--text text--darken-4 text-subtitle-1 px-5">
        <p class="mb-4">
          {{ $t('receivingDeleteDenpyoDialog.message.confirm') }}
        </p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isLoading"> {{ $t('common.action.cancel') }} </v-btn>
        <v-btn color="indigo darken-1" dark @click="ok" :loading="isLoading">
          {{ $t('common.action.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import api from "@/apis/staff";
import constant from "@/utils/constant"
import store from "@/store";

export default {
  props: {
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      dialog: true,
      errorMsg: "",
      alertFlg: false,
    };
  },
  methods: {
    async ok() {
      try {
        this.isLoading = true;
        this.alertFlg = false;

        const response = await api.post("/nyuka/plan/complete", {
          denpyoNumber: store.getNyukaDenpyoNumber(),
        });

        if (response.data?.status != 0) throw "";
        this.handleClose(true);
      } catch (e) {
        this.errorMsg = this.$t('common.message.unknownError');
        this.alertFlg = true;
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      if (this.isLoading) return;
      this.handleClose(false);
    },
  },
};
</script>
<style>
.pre-line {
  white-space: pre-line;
}
</style>

